import type {Home} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useHome() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'homeGlobal',
      depth: 4,
      draft: !!route.query.preview,
    })

    return result as Populated<Home>
  }

  return {
    fetch,
  }
}
